export function setItemWithExpiry(key: string, value: string, expiryTimeInSeconds: number) {
    // Устанавливаем значение в localStorage
    localStorage.setItem(key, value);

    // Запускаем таймер на очистку значения
    setTimeout(() => {
        localStorage.removeItem(key);
    }, expiryTimeInSeconds * 1000);
}